import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { IntegrationService } from '../../../services/integration.service';

@Component({
  selector: 'app-cloud-connect-dialog',
  templateUrl: './cloud-connect-dialog.component.html',
  styleUrl: './cloud-connect-dialog.component.scss',
})
export class CloudConnectDialogComponent implements OnInit {
  @Input() provider!: string;

  loading = true;
  connecting = false;
  connected = false;
  accountEmail: string | null = null;
  accountName: string | null = null;

  get providerLabel() {
    const labels: Record<string, string> = {
      google_drive: 'Google Drive',
      dropbox: 'Dropbox',
      sharepoint: 'SharePoint',
    };
    return labels[this.provider] || this.provider;
  }

  constructor(
    protected dialogRef: NbDialogRef<CloudConnectDialogComponent>,
    private integrationService: IntegrationService,
    private toastr: NbToastrService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    // verify=true actually tests the token against the provider API
    this.integrationService.getCloudStatus(this.provider, true).subscribe({
      next: (status) => {
        this.connected = status.connected;
        this.accountEmail = status.account_email || null;
        this.accountName = status.account_name || null;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  onConnect() {
    this.connecting = true;
    this.integrationService.getCloudAuthUrl(this.provider).subscribe({
      next: (res) => {
        window.location.href = res.auth_url;
      },
      error: () => {
        this.connecting = false;
        this.toastr.danger(
          this.t.instant('components.cloudConnect.connectError'),
          this.t.instant('toasts.error'),
        );
      },
    });
  }

  onDisconnect() {
    this.connecting = true;
    this.integrationService.disconnectCloud(this.provider).subscribe({
      next: () => {
        this.connecting = false;
        this.connected = false;
        this.accountEmail = null;
        this.accountName = null;
        this.toastr.info(
          this.t.instant('components.cloudConnect.disconnected', { provider: this.providerLabel }),
          '',
        );
        this.dialogRef.close(true);
      },
      error: () => {
        this.connecting = false;
        this.toastr.danger(
          this.t.instant('components.cloudConnect.disconnectError'),
          this.t.instant('toasts.error'),
        );
      },
    });
  }

  close() {
    this.dialogRef.close(false);
  }
}
